import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../img/logo.png'


const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "flexRow p-2 withShadow" }
const _hoisted_3 = { class: "col-sm-12 text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "py-2",
  style: {"width":"77%"}
}, null, -1)
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "form-group genericInputGroup" }
const _hoisted_7 = { class: "form-group genericInputGroup posRel" }
const _hoisted_8 = ["type"]
const _hoisted_9 = {
  type: "submit",
  class: "btn btn-primary pull-right"
}
const _hoisted_10 = {
  class: "text-center",
  style: {"margin":"70px 0 10px"}
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_op_select = _resolveComponent("op-select")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (_ctx.$store.state.consts.enabledLanguages)
            ? (_openBlock(), _createBlock(_component_op_select, {
                key: 0,
                class: "w-25 mx-auto my-4",
                options: _ctx.$store.state.consts.enabledLanguages,
                modelValue: _ctx.$store.state.selectedLanguage,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.$store.state.selectedLanguage) = $event))
              }, {
                default: _withCtx((option) => [
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      class: "mr-2",
                      src: require('@/img/langs/' + option.item + '.svg')
                    }, null, 8, _hoisted_5),
                    _createTextVNode(" " + _toDisplayString(option.item.substring(0, 2)), 1)
                  ])
                ]),
                _: 1
              }, 8, ["options", "modelValue"]))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            name: "login",
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.login()), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Email o username",
                  text: "Email o username"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                placeholder: "Email",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vm.email) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.vm.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Password",
                  text: "Password"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                type: _ctx.showPassword ? 'text' : 'password',
                class: "form-control",
                placeholder: "Password",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.vm.password) = $event))
              }, null, 8, _hoisted_8), [
                [_vModelDynamic, _ctx.vm.password]
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-default showPswBtn",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showPassword=!_ctx.showPassword))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Mostra password",
                  text: "Mostra password"
                })
              ])
            ]),
            _createVNode(_component_router_link, {
              to: "/register",
              tag: "a",
              class: "genericLink pull-left",
              style: {"margin":"11px 0","color":"#797979"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_localized_text, {
                  localizedKey: "Non hai un account? Registrati qui",
                  text: "Non hai un account? Registrati qui"
                })
              ]),
              _: 1
            }),
            _createElementVNode("button", _hoisted_9, [
              _createVNode(_component_localized_text, {
                localizedKey: "Login",
                text: "Login"
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_router_link, {
                to: "/request-new-password",
                tag: "a",
                class: "genericLink"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Password dimenticata?",
                    text: "Password dimenticata?"
                  })
                ]),
                _: 1
              })
            ]),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.error), 1)
                ]))
              : _createCommentVNode("", true)
          ], 32)
        ])
      ])
    ])
  ]))
}